import { render, staticRenderFns } from "./RepVenta.vue?vue&type=template&id=55de3b79&"
import script from "./RepVenta.vue?vue&type=script&lang=js&"
export * from "./RepVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports